export enum RecommendedSupportStatus {
  pending = 'Pending',
  booked = 'Booked',
  attended = 'Attended',
}
